import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","PrivacyPolicyDataId"] */ "/codebuild/output/src144142854/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
